const routes = [
  {
    path: '/setting/my_account',
    name: 'AccountPage',
    component: () => import('./views/AccountPage.vue'),
    props: {
      featureFlag: 'rollout.business.account_page_v2.5',
      angularRoute: 'app.settings.my_account'
    },
    meta: {
      i18n: ['account-pov', 'staff-pov', 'app-market-pov', 'subscription-pov', 'premium-pov'],
      pageNameEn: 'My Account'
    },
  },
  {
    path: '/settings/my_account',
    name: 'AccountPage',
    component: () => import('./views/AccountPage.vue'),
    props: {
      featureFlag: 'rollout.business.account_page_v2.5',
      angularRoute: 'app.settings.my_account'
    },
    meta: {
      i18n: ['account-pov', 'staff-pov', 'app-market-pov', 'subscription-pov', 'premium-pov'],
      pageNameEn: 'My Account'
    },
  },
];

export default routes;
